export const LAYER_COLORS = {
	DEFAULT: '#3388ff',
	VIEW: '#26F3FF',
	POST_PROCESSING_REQUEST: '#93be20',
	POST_PROCESSING_RESULTS: '#93be20',
	POST_PROCESSING_REQUEST_OVER: '#ace70f',
};
export const TILE_TYPES = {
	MOSAIC_TILES: 'mosaic_tiles',
	DSM_PSEUDOCOLOR_TILES: 'dsm_pseudocolor_tiles',
	DSM_RAW_TILES: 'dsm_raw_tiles',
	DTM_PSEUDOCOLOR_TILES: 'dtm_pseudocolor_tiles',
	DTM_RAW_TILES: 'dtm_raw_tiles',
	NDRE_PSEUDOCOLOR_TILES: 'ndre_pseudocolor_tiles',
	NDRE_RAW_TILES: 'ndre_raw_tiles',
	NDVI_PSEUDOCOLOR_TILES: 'ndvi_pseudocolor_tiles',
	NDVI_RAW_TILES: 'ndvi_raw_tiles',
	SAVI_PSEUDOCOLOR_TILES: 'savi_pseudocolor_tiles',
	SAVI_RAW_TILES: 'savi_raw_tiles',
	IFV_PSEUDOCOLOR_TILES: 'ifv_pseudocolor_tiles',
	IFV_RAW_TILES: 'ifv_raw_tiles',
	VARI_PSEUDOCOLOR_TILES: 'vari_pseudocolor_tiles',
	VARI_RAW_TILES: 'vari_raw_tiles',
	LEVEL_CURVE: 'level_curve',
};
export const TILE_TYPE_NAMES = {
	[TILE_TYPES.MOSAIC_TILES]: 'Mosaic',
	[TILE_TYPES.DSM_PSEUDOCOLOR_TILES]: 'DSM',
	[TILE_TYPES.DSM_RAW_TILES]: 'DSM',
	[TILE_TYPES.DTM_PSEUDOCOLOR_TILES]: 'DTM',
	[TILE_TYPES.DTM_RAW_TILES]: 'DTM',
	[TILE_TYPES.NDRE_PSEUDOCOLOR_TILES]: 'Índice NDRE',
	[TILE_TYPES.NDRE_RAW_TILES]: 'Índice NDRE',
	[TILE_TYPES.NDVI_PSEUDOCOLOR_TILES]: 'Índice NDVI',
	[TILE_TYPES.NDVI_RAW_TILES]: 'Índice NDVI',
	[TILE_TYPES.SAVI_PSEUDOCOLOR_TILES]: 'Índice SAVI',
	[TILE_TYPES.SAVI_RAW_TILES]: 'Índice SAVI',
	[TILE_TYPES.IFV_PSEUDOCOLOR_TILES]: 'Índice IFV',
	[TILE_TYPES.IFV_RAW_TILES]: 'Índice IFV',
	[TILE_TYPES.VARI_PSEUDOCOLOR_TILES]: 'Índice VARI',
	[TILE_TYPES.VARI_RAW_TILES]: 'Índice VARI',
	[TILE_TYPES.LEVEL_CURVE]: 'Curvas de nível',
};

export const COLOR_TABLES = {
	dsm: ['#0021ff', '#00b7ff', '#53ffc6', '#feff96', '#ff0004'].reverse(),
	dtm: ['#0021ff', '#00b7ff', '#53ffc6', '#feff96', '#ff0004'].reverse(),
	ifv: ['#d7191c', '#fdae61', '#ffffc0', '#a6d96a', '#1a9641'].reverse(),
	savi: ['#d7191c', '#fdae61', '#ffffc0', '#a6d96a', '#1a9641'].reverse(),
	ndvi: ['#d7191c', '#fdae61', '#ffffc0', '#a6d96a', '#1a9641'].reverse(),
	ndre: ['#d7191c', '#fdae61', '#ffffc0', '#a6d96a', '#1a9641'].reverse(),
	vari: ['#d7191c', '#fdae61', '#ffffc0', '#a6d96a', '#1a9641'].reverse(),
};
